import type { Lesson } from '../interfaces'
import type { LessonsStore } from './interfaces'

import { emptyLessonsFilters } from '../../../lib/lessons-query'
import { createLessonsState } from './state'

export const actions = {
  setLoading (this: LessonsStore, payload: LessonsStore['loading']): void {
    this.loading = payload
  },
  /** A ticked row that is no longer on the page cannot be acted on: the selection follows the rows. */
  setLessons (this: LessonsStore, payload: LessonsStore['lessons']): void {
    this.lessons = payload
    this.selectedIds = this.selectedIds.filter(id => payload.some(lesson => lesson.id === id))
  },
  setMeta (this: LessonsStore, payload: LessonsStore['meta']): void {
    this.meta = payload
  },
  setFilters (this: LessonsStore, payload: LessonsStore['filters']): void {
    this.filters = payload
  },
  patchFilters (this: LessonsStore, payload: Partial<LessonsStore['filters']>): void {
    this.filters = { ...this.filters, ...payload }
  },
  resetFilters (this: LessonsStore): void {
    this.filters = emptyLessonsFilters()
  },
  setCurrentPage (this: LessonsStore, payload: LessonsStore['currentPage']): void {
    this.currentPage = payload
  },
  setPerPage (this: LessonsStore, payload: LessonsStore['perPage']): void {
    this.perPage = payload
  },
  toggleSelected (this: LessonsStore, id: number): void {
    this.selectedIds = this.selectedIds.includes(id)
      ? this.selectedIds.filter(selectedId => selectedId !== id)
      : [...this.selectedIds, id]
  },
  /** Ticks every row of the page, or unticks them all when they already are. */
  toggleAllSelected (this: LessonsStore): void {
    const ids = this.lessons.map(lesson => lesson.id)
    const isAllSelected = ids.length > 0 && ids.every(id => this.selectedIds.includes(id))

    this.selectedIds = isAllSelected ? [] : ids
  },
  clearSelected (this: LessonsStore): void {
    this.selectedIds = []
  },
  openDeleteModal (this: LessonsStore, modal: NonNullable<LessonsStore['deleteModal']>, lesson: Lesson | null = null): void {
    this.deleteModal = modal
    this.activeLesson = lesson
  },
  closeDeleteModal (this: LessonsStore): void {
    this.deleteModal = null
    this.activeLesson = null
  },
  setDeleting (this: LessonsStore, payload: LessonsStore['deleting']): void {
    this.deleting = payload
  },
  setSlots (this: LessonsStore, payload: LessonsStore['slots']): void {
    this.slots = payload
  },
  openActionModal (this: LessonsStore, modal: NonNullable<LessonsStore['actionModal']>, lesson: Lesson | null = null): void {
    this.actionModal = modal
    this.actionLesson = lesson
  },
  closeActionModal (this: LessonsStore): void {
    this.actionModal = null
    this.actionLesson = null
  },
  /** The list answer goes with the page it was read for: the next Lessons page starts empty, under its loader, never
   *  showing another discipline's rows until its own land. Filters and paging stay. */
  resetList (this: LessonsStore): void {
    this.lessons = []
    this.meta = null
    this.slots = null
    this.selectedIds = []
  },
  reset (this: LessonsStore): void {
    Object.assign(this, createLessonsState())
  },
}
